var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBridges4CWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275.21 79.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ff3c12;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_x5F_bridges-4c-white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "signet_bottom",
    className: "cls-2",
    d: "M0,53.27h21.39c-5.69,4.56-10.8,9.97-15.23,16.05l13.56,9.86c5.61-7.72,12.43-13.9,19.95-18.11,7.53-4.21,15.72-6.5,24.38-6.5v-18.07H0v16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "signet_top",
    className: "cls-2",
    d: "M56.09,0c-7.25,5.26-15.79,9.17-25.29,11.77-9.49,2.6-19.92,3.87-30.8,3.86v16.77c12.18,0,24.07-1.41,35.23-4.46,11.15-3.05,21.59-7.75,30.71-14.37L56.09,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "cls-1",
    d: "M112.34,44.45c3.07-.83,5.38-4.08,5.38-8.27,0-6.38-3.49-10.58-11.93-10.58h-17.84v5.73h4.14v28.48h-4.14v5.73h17.84c7.8,0,13.83-2.78,13.83-11.34,0-5.08-3.6-8.92-7.27-9.75ZM99.04,31.34h5.61c4.43,0,5.91,2.19,5.91,5.32,0,3.31-1.77,5.44-5.97,5.44h-5.55v-10.75ZM105.42,59.81h-6.38v-12.05h6.32c5.44,0,7.09,2.72,7.09,6.09,0,3.55-1.77,5.97-7.03,5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "cls-1",
    d: "M132.24,44.45v-5.85h-9.98v5.73h3.9v15.01l-3.9,1.06v5.14h16.42v-5.67h-5.97v-11.34c1.18-2.07,3.43-3.37,5.97-3.54l4.79.89.53-7.56c-1.18-.18-2.89-.3-4.14-.3-3.6,0-6.79,3.9-7.62,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot",
    className: "cls-1",
    d: "M155.22,33.23c2.07,0,4.08-1.06,4.08-3.96s-2.01-4.08-4.08-4.08c-2.36,0-4.14,1.24-4.14,4.08s1.77,3.96,4.14,3.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "i",
    className: "cls-1",
    points: "158.77 38.6 146.54 38.6 146.54 44.33 152.21 44.33 152.21 59.87 146.54 59.87 146.54 65.54 164.03 65.54 164.03 59.87 158.77 59.87 158.77 38.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "cls-1",
    d: "M190.73,24.42h-11.64v5.73h5.08v10.69c-1.18-1.36-3.49-2.84-7.39-2.84-7.44,0-11.29,5.26-11.29,14s3.9,14.18,11.05,14.18c4.55,0,7.33-2.78,8.63-4.67.24,2.07,1.65,4.02,4.84,4.02h4.61v-5.67h-3.9V24.42ZM184.17,57.63c-1.06,1.24-3.25,2.36-5.61,2.36-4.79,0-6.26-3.49-6.26-7.98s1.54-7.8,6.32-7.8c2.89,0,4.67,1.12,5.55,1.95v11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    className: "cls-1",
    d: "M224.4,36.48c-2.84-.18-5.55.65-7.44,3.54-1.48-1.12-4.49-2.01-7.09-2.01-8.15,0-12.23,4.43-12.23,10.58,0,3.9,1.65,6.91,4.61,8.51-1.54,1.18-3.31,2.89-3.31,5.5,0,1.48.89,3.13,2.3,3.84-1.89.41-4.55,2.36-4.55,5.44,0,4.2,3.31,7.03,12.11,7.03s14.18-3.96,14.18-9.93c0-5.02-3.49-7.56-9.1-7.56h-8.98l.24-3.6c1.18.41,3.01.59,4.67.59,6.68,0,11.34-3.25,11.34-9.45,0-2.07-.59-4.2-1.54-5.38l4.9-.59-.12-6.5ZM212.47,67.26c2.78,0,3.6,1.24,3.6,2.78,0,2.48-2.84,3.78-7.03,3.78-4.55,0-5.91-1.48-5.91-3.55,0-1.36.83-2.3,1.77-3.01h7.56ZM209.63,53.43c-4.2,0-5.5-2.01-5.5-4.73,0-2.9,1.54-4.9,5.5-4.9,3.72,0,5.32,2.01,5.32,4.9s-1.42,4.73-5.32,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "cls-1",
    d: "M249.39,49.65c0-5.79-3.13-11.64-11.34-11.64s-12.41,6.38-12.41,14.06c0,8.21,3.84,14.12,13.18,14.12,3.55,0,7.44-1.18,10.28-2.95l-2.13-5.2c-2.48,1.48-5.26,2.3-8.09,2.3-4.14,0-6.14-2.3-6.26-6.09h16.31c.3-1.12.47-3.13.47-4.61ZM242.95,49.3h-10.28c.24-3.19,1.65-5.79,5.38-5.79,2.72,0,4.96,1.65,4.96,4.96,0,.18,0,.47-.06.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "cls-1",
    d: "M267.82,49.77l-4.25-1.3c-1.95-.65-2.48-1.6-2.48-2.89,0-1.48,1.06-2.84,3.43-2.84,1.48,0,2.66.24,3.72.65l.77,3.6h5.2v-7.27c-2.3-1-6.2-1.71-9.69-1.71-8.33,0-10.75,4.55-10.75,8.33,0,4.08,2.36,6.62,6.91,8.03l4.49,1.42c1.77.59,2.6,1.6,2.6,2.9,0,1.83-1.48,2.84-3.78,2.84-1.6,0-3.13-.3-4.2-.83l-1.18-4.02h-5.2l.47,7.68c2.89,1.18,6.03,1.83,10.16,1.83,8.39,0,11.17-4.2,11.17-8.27s-2.48-6.62-7.39-8.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBridges4CWhite);
export default __webpack_public_path__ + "static/media/logo_bridges-4c-white.5198b88b89a979d5fe33ec7f7926f108.svg";
export { ForwardRef as ReactComponent };